import { render, staticRenderFns } from "./TheOrganizationList.vue?vue&type=template&id=6a9b6f64&"
import script from "./TheOrganizationList.vue?vue&type=script&lang=ts&"
export * from "./TheOrganizationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports